import { templateThemeTokens } from './templateThemeTokens.js';
import { THEME_DEFAULT_FONTS } from '@/contexts/CustomThemeConfigContext/constants.js';
import { createTheme } from '@/stitches/index.js';

export const midday = createTheme({
  ...templateThemeTokens,
  colors: {
    defaultFont: '#23413A',
    pageBackground: '#F0FB96',
  },
  fonts: {
    accent: THEME_DEFAULT_FONTS.sydney.midday.accent
      ? THEME_DEFAULT_FONTS.sydney.midday.accent.value
      : 'unset',
    body: THEME_DEFAULT_FONTS.sydney.midday.body.value,
    heading: THEME_DEFAULT_FONTS.sydney.midday.headline.value,
  },
});
